<template>
  <Transition name="slide">
    <IconButton
      v-if="showBackToTop"
      class="back-to-top"
      icon="arrow-up"
      theme="white"
      @click="scrollToTop"
    />
  </Transition>
</template>

<script>
import IconButton from "@/components/IconButton.vue";

export default {
  name: "BackToTop",
  components: {
    IconButton,
  },
  data() {
    return {
      showBackToTop: false,
      scrollTimeout: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showBackToTop = false;
      clearTimeout(this.scrollTimeout);

      this.scrollTimeout = setTimeout(() => {
        this.showBackToTop = window.scrollY > 0;
      }, 400);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.back-to-top {
  background: $color-white;
  border: none;
  box-shadow: 2px 4px 10px 0px rgba($color-black, 0.04);
  position: fixed !important;
  bottom: 100px;
  right: 30px;
  border-radius: 50%;
  padding: 14px;
  font-size: 20px;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
